/**
 * The router's cross-route animation: the browser's View Transitions API on every navigation, except
 * while the page is hidden. A hidden document makes `document.startViewTransition` reject its `ready`
 * promise with an `InvalidStateError` the router never handles, and the route only commits once the
 * browser paints a frame, which a background tab may not do for a long time. Returning `false` from
 * `types` makes the router commit directly instead.
 *
 * The router reads `types` only where the browser supports view transition types, the same check it
 * makes itself. A browser without them would run every transition, hidden or not, so there the
 * animation is off.
 */
export function viewTransitionOption():
  false | { types: () => false | string[] } {
  const supportsTypes =
    typeof CSS !== 'undefined' &&
    typeof CSS.supports === 'function' &&
    CSS.supports('selector(:active-view-transition-type(a))');
  if (!supportsTypes) return false;
  return {
    types: () => (document.visibilityState === 'hidden' ? false : []),
  };
}
